import PropTypes from 'prop-types';
import { Card, Link } from '../../Atoms';

const DataCard = ({ title, subtitle, intro, url, className = '' }) => {
  if (!title) return null;

  const cardContent = (
    <Card className={`card-data border-thick ${className}`}>
      <div className="block">
        <div className="block__body">
          <div className="stack stack-tight">
            <div className="text-item-title line-clamp-2">{title}</div>
            {subtitle && <div className="text-label line-clamp-1">{subtitle}</div>}
            {intro && <div className="text-body line-clamp-4">{intro}</div>}
          </div>
        </div>
      </div>
    </Card>
  );

  if (url) {
    return (
      <Link href={url} className="block no-underline">
        {cardContent}
      </Link>
    );
  }
  return cardContent;
};

DataCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  intro: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
};

export default DataCard;